import AjaxUtils from '../../util/ajax_utils';
import Vue from 'vue';
import { ApckTrustScanStatusColumn } from './trust_columns';

export const ApckTrustScans = {
    props: {
        dataSrc: {
            type: String,
            default: '/trust/scans/list',
        },
        historySrc: {
            type: String,
            default: '/trust/scans/history',
        },
    },
    data: function () {
        return {
            loading: false,
            current: null,
            totalScans: 0,
            nextScanAt: null,
            nextScanOverdue: false,
            scanRepeatInterval: '',
            scanTriggering: false,
            scanAborting: false,
            pollTimer: null,
            cols: [
                { data: 'status', heading: 'Status', ctype: 'trust-scan-status', width: 120 },
                { data: 'started_at', heading: 'Started', ctype: 'datecolumn', width: 160 },
                { data: 'last_update_at', heading: 'Last Update', ctype: 'datecolumn', width: 160 },
                { data: 'finished_at', heading: 'Finished', ctype: 'datecolumn', width: 160 },
                { data: 'duration', heading: 'Duration', width: 100 },
                { data: 'triggered_by', heading: 'Triggered By', width: 180 },
                { data: 'error_message', heading: 'Error' },
            ],
        }
    },
    computed: {
        nextScanLabel: function () {
            if (this.isRunning || this.isAborting) {
                return 'After current scan'
            }
            if (this.nextScanOverdue) {
                if (this.nextScanAt) {
                    return 'Overdue \u2014 next window: ' + this.formatDate(this.nextScanAt)
                }
                return 'Overdue \u2014 pending'
            }
            if (!this.nextScanAt) return 'Not scheduled'
            return this.formatDate(this.nextScanAt)
        },
        currentStatusLabel: function () {
            if (!this.current) return 'Idle'
            return this.current.status.charAt(0).toUpperCase() + this.current.status.slice(1)
        },
        isRunning: function () {
            return this.current && (this.current.status === 'running' || this.current.status === 'initializing' || this.current.status === 'queued' || this.current.status === 'pending')
        },
        isAborting: function () {
            return this.current && this.current.status === 'aborting'
        },
    },
    methods: {
        refresh: function () {
            var cmp = this
            cmp.loading = true

            AjaxUtils.ajax_get({
                url: cmp.dataSrc,
                success: function (data) {
                    cmp.loading = false
                    if (data && data.success) {
                        cmp.current = data.data.current || null
                        cmp.totalScans = data.data.total_count || 0
                        cmp.nextScanAt = data.data.next_scan_at || null
                        cmp.nextScanOverdue = data.data.next_scan_overdue || false
                        cmp.scanRepeatInterval = data.data.scan_repeat_interval || ''
                    }
                    if (cmp.$refs.scanHistoryTable) {
                        cmp.$refs.scanHistoryTable.store.load()
                    }
                },
                fail: function () {
                    cmp.loading = false
                },
                opts: {
                    dataType: 'json',
                    flash_form_errors: false,
                    show_success_flash: false,
                    flash_404_errors: false,
                }
            })
        },
        runScanNow: function () {
            var cmp = this
            cmp.scanTriggering = true

            AjaxUtils.ajax_get({
                url: '/trust/scan/run-now',
                success: function (data) {
                    cmp.scanTriggering = false
                    if (data && data.success) {
                        cmp.refresh()
                    }
                },
                fail: function () {
                    cmp.scanTriggering = false
                },
                opts: {
                    dataType: 'json',
                }
            })
        },
        abortScan: function () {
            var cmp = this
            cmp.scanAborting = true

            AjaxUtils.ajax_get({
                url: '/trust/scan/abort',
                success: function (data) {
                    cmp.scanAborting = false
                    if (data && data.success) {
                        cmp.refresh()
                    }
                },
                fail: function () {
                    cmp.scanAborting = false
                },
                opts: {
                    dataType: 'json',
                }
            })
        },
        formatDate: function (iso) {
            if (!iso) return '-'
            var d = new Date(iso)
            var day = ('0' + d.getDate()).slice(-2)
            var month = ('0' + (d.getMonth() + 1)).slice(-2)
            var year = d.getFullYear()
            var hours = ('0' + d.getHours()).slice(-2)
            var mins = ('0' + d.getMinutes()).slice(-2)
            return day + '/' + month + '/' + year + ' ' + hours + ':' + mins
        },
    },
    created: function () {
        Vue.component('apck-trust-scan-status', ApckTrustScanStatusColumn);
    },
    mounted: function () {
        var cmp = this
        cmp.refresh()
        cmp.pollTimer = setInterval(function () {
            cmp.refresh()
        }, 15000)
    },
    beforeDestroy: function () {
        if (this.pollTimer) {
            clearInterval(this.pollTimer)
            this.pollTimer = null
        }
    },
    template: `
        <div class="new-ui">
            <div class="page-title-bar--sticky">
                <ui-page-title-bar title="Trust Monitor Scans">
                    <ui-split-button
                        v-if="isAborting"
                        label="Aborting"
                        iconLeft="fa-spinner fa-spin"
                        type="outline"
                        color="red"
                        disabled
                        secondaryLabel="Scan Settings"
                        secondaryIcon="fa-cog"
                        secondaryUrl="/trust/settings?tab=scan"
                    />
                    <ui-split-button
                        v-else-if="isRunning"
                        label="Abort Scan"
                        iconLeft="fa-stop"
                        type="outline"
                        color="red"
                        :disabled="scanAborting"
                        secondaryLabel="Scan Settings"
                        secondaryIcon="fa-cog"
                        secondaryUrl="/trust/settings?tab=scan"
                        @click="abortScan"
                    />
                    <ui-split-button
                        v-else
                        label="Run Scan Now"
                        iconLeft="fa-play"
                        type="outline"
                        :disabled="scanTriggering"
                        secondaryLabel="Scan Settings"
                        secondaryIcon="fa-cog"
                        secondaryUrl="/trust/settings?tab=scan"
                        @click="runScanNow"
                    />
                    <ui-button
                        label="Refresh"
                        iconLeft="fa-refresh"
                        type="outline"
                        @click.prevent="refresh"
                    />
                </ui-page-title-bar>
            </div>

            <ui-layout type="grid" cols="9" class="apck-trust-dashboard">
                <div class="portlet col col-span-3">
                    <apck-panel title="Current Status" icon="fa-circle-info">
                        <div class="scan-info-content">
                            <div class="scan-info-row">
                                <ui-badge
                                    :label="currentStatusLabel"
                                    :color="isRunning ? 'blue' : 'light-slate'"
                                    :iconLeft="isRunning ? 'fa-spinner fa-spin' : ''"
                                />
                                <span v-if="current && current.triggered_by" class="scan-info-muted">
                                    by {{ current.triggered_by }}
                                </span>
                            </div>
                            <div v-if="current && current.started_at" class="scan-info-detail">
                                Started: {{ formatDate(current.started_at) }}
                            </div>
                            <div v-if="current && current.last_update_at" class="scan-info-detail">
                                Last Update: {{ formatDate(current.last_update_at) }}
                            </div>
                        </div>
                    </apck-panel>
                </div>

                <div class="portlet col col-span-3">
                    <apck-panel title="Next Scheduled Scan" icon="fa-calendar-clock">
                        <div class="scan-info-content">
                            <div class="scan-info-value">{{ nextScanLabel }}</div>
                            <div v-if="scanRepeatInterval" class="scan-info-detail">
                                Repeat: {{ scanRepeatInterval }}
                            </div>
                            <div v-else class="scan-info-detail">
                                No schedule configured
                            </div>
                        </div>
                    </apck-panel>
                </div>

                <div class="portlet col col-span-3">
                    <ui-panel-counter
                        title="Total Scans"
                        :value="totalScans"
                        color="light-slate"
                        :loading="false"
                    />
                </div>

                <div class="portlet col col-span-9">
                    <apck-panel title="Scan History" icon="fa-clock-rotate-left" no-padding class="trust-data-panel">
                        <apck-table
                            ref="scanHistoryTable"
                            :columns="cols"
                            :src="historySrc"
                            :limit="25"
                            :border="false"
                            :show-toolbar="false"
                            newStyleTable
                        />
                    </apck-panel>
                </div>
            </ui-layout>
        </div>
    `,
}
